import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22theme.tsx%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:%22./fonts/GeneralSans-Medium.woff2%22,%22display%22:%22swap%22}],%22variableName%22:%22GSFont%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'GSFont', 'GSFont Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
